class ProductPage {
  constructor() {
    this.savedParams = '';
    this.currentVarID = document.getElementById('id').value;
    this.init();
  }

  init() {
    this.saveURLParams();
    this.attachEventListeners();
    this.updateSizeLabels(); // Call on load
    this.recordInitialSize(); // Record the initial size on page load
    this.autoSelectSizeFromCookie(); // Auto-select size on page load
    this.trackViewedProduct(); // Track product view
    this.displayViewedProducts();
    this.checkIfAllVariantsOutOfStock(); // Checking for entirely out of stock product
  }
  
  displayViewedProducts() {
    let dpUserCookie = CookieManager.getCookie('dp_user');
    if (!dpUserCookie) return;

    let cookieData = JSON.parse(dpUserCookie);
    let viewedHistory = cookieData.viewedHistory || [];
    if (viewedHistory.length < 3) {
      console.log('Fewer than 3 products in viewedHistory. Canceling script.');
      return;
    }

    const viewedHistoryContainer = document.getElementById('viewedHistory');
    const viewedHistoryList = document.getElementById('viewedHistoryList');
    if (!viewedHistoryList) return;

    viewedHistoryList.innerHTML = '';
    viewedHistoryContainer.style.display = 'block';

    viewedHistory.forEach(product => {
      const productDiv = document.createElement('div');
      productDiv.className = 'viewed-product';

      const productLink = document.createElement('a');
      productLink.href = `/products/${product.handle}`;
      productLink.title = product.title;

      const productImage = document.createElement('img');
      productImage.src = product.image;
      productImage.alt = product.title;

      const productTitle = document.createElement('h3');
      productTitle.textContent = product.title;
      productTitle.className = 'title';

      const productPrice = document.createElement('p');
      productPrice.textContent = product.price;
      productPrice.className = 'price';

      const productCompareDiv = document.createElement('div');
      productCompareDiv.className = 'compare-product';
      const productCompareDivDl = document.createElement('dl');
      
      productCompareDiv.appendChild(productCompareDivDl);
      const productDivTop = document.createElement('div');
      productDivTop.className = 'product-top';

      productDivTop.appendChild(productImage);
      productDivTop.appendChild(productTitle);
      productDivTop.appendChild(productPrice);
      productLink.appendChild(productDivTop);
      productLink.appendChild(productCompareDiv);


      productDiv.appendChild(productLink);
      viewedHistoryList.appendChild(productDiv);

      // Load metafields asynchronously after displaying the main product content
      this.fetchProductMetafields(product.handle, productCompareDivDl);
    });
    this.setupToggleCompareButton();
    this.setupViewedProductsSwiper();
  }


  setFocusTrap(container) {
    const focusableElements = Array.from(
      container.querySelectorAll(
        'a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select, [tabindex]:not([tabindex="-1"])'
      )
    );
  
    if (focusableElements.length) {
      const firstFocusable = focusableElements[0];
      const lastFocusable = focusableElements[focusableElements.length - 1];
  
      container.addEventListener('keydown', (e) => {
        if (e.key !== 'Tab') return;
  
        if (e.shiftKey && document.activeElement === firstFocusable) {
          e.preventDefault();
          lastFocusable.focus();
        } else if (!e.shiftKey && document.activeElement === lastFocusable) {
          e.preventDefault();
          firstFocusable.focus();
        }
      });
  
      // Set initial focus when opening the container
      firstFocusable.focus();
    }
  }
  
  removeFocusTrap(container) {
    container.removeEventListener('keydown', this.handleFocusTrap);
  }

  setupToggleCompareButton() {
    const toggleButton = document.querySelector('.toggle-compare');
    const toggleButtonText = document.querySelector('.toggle-compare-text');
    if (!toggleButton) return;

    toggleButton.addEventListener('click', () => {
      const compareProducts = document.querySelectorAll('.compare-product');
      const isOpen = compareProducts[0].hasAttribute('open');

      compareProducts.forEach(compareProduct => {
        if (isOpen) {
          compareProduct.removeAttribute('open');
        } else {
          compareProduct.setAttribute('open', '');
        }
      });

      toggleButtonText.textContent = isOpen ? 'Compare Features' : 'Hide Compare';
    });
  }

  async fetchProductMetafields(handle, productCompareDivDl) {
    const storeDomain = 'dan-post-boots.myshopify.com';
    const accessToken = 'e3f33571ef59636cb618d377b9561438';
    const metafieldNamespace = "meta"; // Adjusted to match your Liquid setup
    const metafieldKeys = [
      "feature_shaftmat",
      "heel_height",
      "feature_height",
      "feature_circum",
      "feature_lining",
      "feature_toe",
      "feature_outsole",
      "feature_insole"
    ];
  
    const query = `
      {
        productByHandle(handle: "${handle}") {
          ${metafieldKeys
            .map(
              (key) => `
            ${key}: metafield(namespace: "${metafieldNamespace}", key: "${key}") {
              value
            }`
            )
            .join("\n")}
        }
      }
    `;
  
    try {
      const response = await fetch(`https://${storeDomain}/api/2023-10/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': accessToken
        },
        body: JSON.stringify({ query })
      });
  
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
  
      const data = await response.json();
      const product = data.data.productByHandle;
      if (product) {
        console.log('Product Data:', product);
  
        // Update the title with `short_name` if available
        const shortName = product.short_name?.value;
        if (shortName) {
          const productTitleElement = productCompareDivDl.closest('.viewed-product').querySelector('.title');
          if (productTitleElement) {
            productTitleElement.textContent = shortName;
          }
        }
  
        // Render each metafield or create a blank entry if missing
        metafieldKeys.forEach((key) => {
          const metafield = product[key];
  
          // Define labels based on key names
          let labelText;
          if (key === "feature_shaftmat") {
            labelText = "Shaft";
          } else if (key === "heel_height") {
            labelText = "Heel";
          } else if (key === "feature_height") {
            labelText = "Height";
          } else if (key === "feature_lining") {
            labelText = "Lining";
          } else if (key === "feature_toe") {
            labelText = "Toe";
          } else if (key === "feature_outsole") {
            labelText = "Outsole";
          } else if (key === "feature_insole") {
            labelText = "Comfort System";
          } else if (key === "feature_circum") {
            labelText = "Circumference";
          } else {
            labelText = key.replace('_', ' ').toUpperCase(); // Default fallback
          }
  
          // Create and append dt and dd elements
          const dt = document.createElement('dt');
          const dd = document.createElement('dd');
          dt.textContent = labelText;
          dd.textContent = metafield?.value || "--"; // Add value if available, otherwise leave blank
          productCompareDivDl.appendChild(dt);
          productCompareDivDl.appendChild(dd);
  
          console.log(`Metafield [${key}]: ${metafield ? metafield.value : 'Not available (empty entry created)'}`);
        });
      }
    } catch (error) {
      console.error('Failed to fetch product data:', error);
    }
  }
  
  
  setupViewedProductsSwiper() {
    // Elements
    const viewedHistory = document.getElementById('viewedHistory');
    const viewedContainer = document.querySelector('.viewed-container');
    const viewedList = document.getElementById('viewedHistoryList');

    // Create navigation arrows
    const prevArrow = document.createElement('button');
    prevArrow.className = 'prev-arrow';
    prevArrow.style.display = 'none'; // Initially hidden

    const nextArrow = document.createElement('button');
    nextArrow.className = 'next-arrow';
    nextArrow.style.display = 'none'; // Initially hidden

    // Add arrows to the container
    viewedHistory.appendChild(prevArrow);
    viewedHistory.appendChild(nextArrow);

    // Function to check if arrows should be visible
    const updateArrows = () => {
      const containerRect = viewedContainer.getBoundingClientRect();
      const lastChildRect = viewedList.lastElementChild.getBoundingClientRect();
      const firstChildRect = viewedList.firstElementChild.getBoundingClientRect();

      // Check if any product goes off the right edge
      if (lastChildRect.right > containerRect.right) {
        nextArrow.style.display = 'block';
      } else {
        nextArrow.style.display = 'none';
      }

      // Check if any product goes off the left edge
      if (firstChildRect.left < containerRect.left) {
        prevArrow.style.display = 'block';
      } else {
        prevArrow.style.display = 'none';
      }
    };

    // Scroll functions
    const scrollNext = () => {
      const productWidth = viewedList.querySelector('.viewed-product').offsetWidth;
      viewedContainer.scrollBy({ left: productWidth, behavior: 'smooth' });
    };

    const scrollPrev = () => {
      const productWidth = viewedList.querySelector('.viewed-product').offsetWidth;
      viewedContainer.scrollBy({ left: -productWidth, behavior: 'smooth' });
    };

    // Event listeners for arrows
    nextArrow.addEventListener('click', scrollNext);
    prevArrow.addEventListener('click', scrollPrev);

    // Update arrows on scroll and resize
    viewedContainer.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);

    // Initial check for arrow visibility
    updateArrows();
  }


  recordInitialSize() {
    let selectedSizeLabel = document.querySelector('.product-form__input.set-size label.selected');
    if (selectedSizeLabel) {
      let selectedSizeValue = selectedSizeLabel.getAttribute('data-value');
      let dataIdentifier = document.getElementById('data-identifier');
      if (dataIdentifier) {
        console.log('Recording initial size:', selectedSizeValue); // Log the initial size
        dataIdentifier.setAttribute('size', selectedSizeValue);
      }
    }
  }

  saveURLParams() {
    const urlParams = new URLSearchParams(window.location.search);
    for (const [key, value] of urlParams.entries()) {
      if (key !== 'variant') {
        this.savedParams += `&${key}=${value}`;
      }
    }
    window.history.replaceState({}, '', `?variant=${this.currentVarID}${this.savedParams}`);
  }

  attachEventListeners() {
    this.restoreFocusAfterNavigation();
    document.querySelectorAll('.product-form__input.set-width label').forEach(label => {
      label.addEventListener('click', this.cancelWidthAutoFocus.bind(this));
      label.addEventListener('click', this.filterLabels.bind(this, label));
      label.addEventListener('click', this.updateSizeLabels.bind(this)); // Update size labels on width switch
    });

    document.querySelectorAll('.product-form__input label').forEach(label => {
      label.addEventListener('click', this.cancelWidthAutoFocus.bind(this));
      label.addEventListener('click', this.selectVariant.bind(this, label));
      label.addEventListener('click', this.updateSizeLabels.bind(this)); // Update size labels on variant switch

      label.addEventListener('focusin', this.cancelWidthAutoFocus.bind(this));

      // Add keydown listener for 'Enter' and 'Space'
      label.addEventListener('keydown', (e) => {
        if (e.key === 'Tab') {
          this.cancelWidthAutoFocus();
        }

        if (e.key.startsWith('Arrow')) {
          this.cancelWidthAutoFocus();
          this.handleVariantArrowNavigation(label, e);
          return;
        }

        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar' || e.key === 'Space' || e.code === 'Space') {
          e.preventDefault();
          this.selectVariant(label);
          this.updateSizeLabels();
        }
      });

      // Fallback for assistive tech that triggers activation on keyup
      label.addEventListener('keyup', (e) => {
        if (e.key === ' ' || e.key === 'Spacebar' || e.key === 'Space' || e.code === 'Space') {
          e.preventDefault();
          this.selectVariant(label);
          this.updateSizeLabels();
        }
      });
    
    });

    // Ensure activation works when assistive tech targets the native input
    document.querySelectorAll('.product-form__input input[type="radio"]').forEach(input => {
      input.addEventListener('change', () => {
        const label = input.nextElementSibling;
        if (label && label.tagName === 'LABEL') {
          this.selectVariant(label);
          this.updateSizeLabels();
        }
      });
      input.addEventListener('click', () => {
        const label = input.nextElementSibling;
        if (label && label.tagName === 'LABEL') {
          this.selectVariant(label);
          this.updateSizeLabels();
        }
      });
    });

    document.querySelectorAll('.quantity__button').forEach(button => {
      button.addEventListener('click', this.updateQuantity.bind(this, button));
    });

    document.querySelector('.btn-product-add-to-cart.push-first').addEventListener('click', this.addToCart.bind(this));

    document.querySelectorAll('.hover-zoom').forEach(container => {
      container.addEventListener('mouseenter', this.hoverZoomEnter.bind(this, container));
      container.addEventListener('mouseleave', this.hoverZoomLeave.bind(this, container));
      container.addEventListener('mousemove', this.hoverZoomMove.bind(this, container));
    });

    window.addEventListener("load", this.checkHoverZoom.bind(this));
    window.addEventListener("resize", this.checkHoverZoom.bind(this));

    // Initialize selection summary
    this.updateSelectionSummaryFromSelected();
  }

  getSelectableLabelsInSet(label) {
    const set = label?.closest('.variant-set');
    if (!set) return [];

    return Array.from(set.querySelectorAll('label[role="radio"]')).filter((candidate) => {
      if (candidate.getAttribute('aria-disabled') === 'true') return false;
      return candidate.offsetParent !== null;
    });
  }

  handleVariantArrowNavigation(label, event) {
    const isForward = event.key === 'ArrowRight' || event.key === 'ArrowDown';
    const isBackward = event.key === 'ArrowLeft' || event.key === 'ArrowUp';
    if (!isForward && !isBackward) return;

    const labels = this.getSelectableLabelsInSet(label);
    if (labels.length <= 1) return;

    const currentIndex = labels.indexOf(label);
    if (currentIndex < 0) return;

    event.preventDefault();

    const nextIndex = isForward
      ? (currentIndex + 1) % labels.length
      : (currentIndex - 1 + labels.length) % labels.length;

    const nextLabel = labels[nextIndex];
    if (!nextLabel) return;

    nextLabel.focus();
    this.selectVariant(nextLabel);
    this.updateSizeLabels();
  }

  cancelWidthAutoFocus() {
    if (this.widthFocusTimeout) {
      window.clearTimeout(this.widthFocusTimeout);
      this.widthFocusTimeout = null;
    }
  }

  filterLabels(label) {
    let testFirstOption = label.getAttribute('data-value');
    let selectedTestLabels = document.querySelectorAll('.set-size label');

    selectedTestLabels.forEach(testLabel => {
      let nameTestItem = testLabel.getAttribute('data-value');
      let testScenario = nameTestItem + ' / ' + testFirstOption;
      let testCounter = 0;

      document.querySelectorAll('#ProductSelect-product-template > option').forEach(option => {
        let thisOptName = option.textContent.trim();
        if (thisOptName.indexOf(testScenario) > -1) {
          testCounter++;
        }
      });

      testLabel.style.display = testCounter <= 0 ? 'none' : '';
    });

    this.updateSizeLabels(); // Update size labels on width change
  }

  updateSizeLabels() {
    let selectedWidth = document.querySelector('.product-form__input.set-width label.selected');
    if (!selectedWidth) return;

    let selectedWidthValue = selectedWidth.getAttribute('data-value');
    let sizeLabels = document.querySelectorAll('.product-form__input.set-size label');

    sizeLabels.forEach(sizeLabel => {
      let sizeValue = sizeLabel.getAttribute('data-value');
      let variantFound = false;

      document.querySelectorAll('#ProductSelect-product-template > option').forEach(option => {
        let optionText = option.textContent.trim();
        let optionInv = option.getAttribute('data-inv');
        let variantText = `${sizeValue} / ${selectedWidthValue}`;

        if (optionText.indexOf(variantText) > -1 && optionInv == 0) {
          sizeLabel.classList.add('out-of-stock');
          sizeLabel.setAttribute('aria-disabled', 'true');
          sizeLabel.setAttribute('tabindex', '0');

          const inputId = sizeLabel.getAttribute('for');
          const input = inputId ? document.getElementById(inputId) : null;
          if (input) input.setAttribute('disabled', 'true');

          let status = sizeLabel.querySelector('.availability-status');
          if (!status) {
            status = sizeLabel.querySelector('.visually-hidden');
            if (!status) {
              status = document.createElement('span');
              status.className = 'visually-hidden availability-status';
              sizeLabel.appendChild(status);
            }
          }
          status.textContent = 'Unavailable';

          // Update aria-label to include Unavailable
          let currentLabel = sizeLabel.getAttribute('aria-label');
          if (currentLabel && !currentLabel.includes('Unavailable')) {
            sizeLabel.setAttribute('aria-label', currentLabel + ' Unavailable');
          }

          variantFound = true;
        }
      });

      if (!variantFound) {
        sizeLabel.classList.remove('out-of-stock');
        sizeLabel.removeAttribute('aria-disabled');
        sizeLabel.setAttribute('tabindex', '0');

        const inputId = sizeLabel.getAttribute('for');
        const input = inputId ? document.getElementById(inputId) : null;
        if (input) input.removeAttribute('disabled');

        const status = sizeLabel.querySelector('.availability-status');
        if (status) status.remove();

        // Remove Unavailable from aria-label if it was added
        let currentLabel = sizeLabel.getAttribute('aria-label');
        if (currentLabel && currentLabel.includes(' Unavailable')) {
          sizeLabel.setAttribute('aria-label', currentLabel.replace(' Unavailable', ''));
        }
      }
    });
  }

  checkIfAllVariantsOutOfStock() {
    const variantOptions = document.querySelectorAll('#ProductSelect-product-template option');
    const variantSets = document.querySelectorAll('.product-form__input.variant-set');

    if (!variantOptions.length || !variantSets.length) return;

    // Check if every variant has data-inv="0"
    const allOutOfStock = Array.from(variantOptions).every(
      opt => opt.getAttribute('data-inv') === '0'
    );

    if (allOutOfStock) {
      console.log('All variants are out of stock.');

      variantSets.forEach(set => {
        // Disable visually + functionally
        set.classList.add('is-disabled');
        set.disabled = true;
        set.setAttribute('aria-disabled', 'true');
        set.setAttribute('aria-label', 'All variants are sold out');

        // Find and update all clickable elements inside (inputs, labels, buttons)
        const interactiveEls = set.querySelectorAll('label, input, button, [tabindex]');
        interactiveEls.forEach(el => {
          el.setAttribute('tabindex', '-1');
          el.setAttribute('aria-hidden', 'true');
          el.setAttribute('aria-disabled', 'true');
        });
      });

      // Optionally disable Add to Cart button
      const addToCartButton = document.querySelector('.btn-product-add-to-cart');
      if (addToCartButton) {
        addToCartButton.setAttribute('disabled', 'true');
        addToCartButton.setAttribute('aria-disabled', 'true');
        const btnText = addToCartButton.querySelector('span');
        if (btnText) btnText.textContent = 'Sold Out';
      }

      // Optional: announce to screen readers immediately
      const liveRegion = document.getElementById('live-region') || (() => {
        const region = document.createElement('div');
        region.id = 'live-region';
        region.setAttribute('aria-live', 'polite');
        region.setAttribute('role', 'status');
        region.style.position = 'absolute';
        region.style.left = '-9999px';
        document.body.appendChild(region);
        return region;
      })();
      liveRegion.textContent = 'All variants of this product are currently out of stock.';
    }
  }

  selectVariant(label) {
    // Prevent selection of unavailable options
    if (label.getAttribute('aria-disabled') === 'true') {
      return;
    }

    const inputId = label.getAttribute('for');
    const linkedInput = inputId ? document.getElementById(inputId) : null;
    if (linkedInput && !linkedInput.disabled) {
      linkedInput.checked = true;
    }

    if (label.getAttribute('data-handle')) {
      const focusTarget = label.closest('variant-radios')?.id || 'product-variants';
      sessionStorage.setItem('restoreFocusId', focusTarget);
      sessionStorage.setItem('restoreScrollY', String(window.scrollY));
      return window.location.assign(`/products/${label.getAttribute('data-handle')}#${focusTarget}`);
    }
    let parent = label.parentElement;
    parent.querySelectorAll('label').forEach(l => l.classList.remove('selected'));
    parent.querySelectorAll('label[role="radio"]').forEach(l => l.setAttribute('aria-checked', 'false'));
    label.classList.add('selected');
    if (label.getAttribute('role') === 'radio') {
      label.setAttribute('aria-checked', 'true');
    }
    
    let optname = '';
    let selectedLabels = document.querySelectorAll('.product-form__input label.selected');
    selectedLabels.forEach((selectedLabel, i) => {
      let nameItem = selectedLabel.getAttribute('data-value');
      optname += i === 0 ? nameItem : ' / ' + nameItem;
    });
    optname = optname.trim();
    
    let varid = '', varinv = '', varprice = '', varpriceCents = 0, varcompare = '', varcompareCents = 0;
    document.querySelectorAll('#ProductSelect-product-template > option').forEach(option => {
      let thisOptName = option.textContent.trim();
      if (thisOptName === optname) {
        varid = option.value;
        varinv = option.getAttribute('data-inv');
        varprice = option.getAttribute('data-price');
        varpriceCents = Number(option.getAttribute('data-price-cents') || 0);
        varcompare = option.getAttribute('data-compare-price') || '';
        varcompareCents = Number(option.getAttribute('data-compare-cents') || 0);
        document.querySelectorAll('#ProductSelect-product-template > option').forEach(opt => opt.removeAttribute('selected'));
        option.setAttribute('selected', 'selected');
        window.history.replaceState({}, '', `?variant=${varid}${this.savedParams}`);
        document.querySelector('input[name="id"]').value = varid;
        document.querySelector('.price-num').innerHTML = varprice;

        const compareAtElement = document.querySelector('#PdpCompareAtPrice');
        if (compareAtElement) {
          if (varcompareCents > varpriceCents) {
            compareAtElement.textContent = varcompare;
            compareAtElement.style.display = '';
          } else {
            compareAtElement.style.display = 'none';
          }
        }
      }
    });
    
    // Find the selected size and update #data-identifier
    const selectedSize = document.querySelector('.product-form__input.set-size label.selected');
    if (selectedSize) {
      const sizeValue = selectedSize.getAttribute('data-value');
      const dataIdentifier = document.getElementById('data-identifier');
      if (dataIdentifier) {
        console.log('Selected size:', sizeValue); // Log the selected size
        dataIdentifier.setAttribute('size', sizeValue);
      }
    }
    
    this.updateUIBasedOnVariant(varid, varinv, selectedLabels);
    this.updateSizeLabels(); // Update size labels on variant switch
    this.announceVariantSelection(label);
    this.updateSelectionSummaryFromSelected();

    // Removed auto-focus to width after size selection
  }

  announceVariantSelection(label) {
    const liveRegion = document.getElementById('variant-selection-live') || (() => {
      const region = document.createElement('div');
      region.id = 'variant-selection-live';
      region.setAttribute('aria-live', 'polite');
      region.setAttribute('role', 'status');
      region.className = 'visually-hidden';
      document.body.appendChild(region);
      return region;
    })();

    const labelSet = label?.closest('.variant-set');
    const rawOptionName = labelSet?.querySelector('legend')?.textContent?.replace(/\s+/g, ' ').trim() || 'Option';
    const optionName = rawOptionName
      .replace(/^Select\s+a\s+/i, '')
      .replace(/^Select\s+/i, '')
      .replace(/:$/, '')
      .trim();
    const value = label?.getAttribute('data-value') || label?.textContent.trim();

    if (value) {
      liveRegion.textContent = `${optionName} ${value} selected`;
    }
  }

  normalizeOptionName(rawOptionName) {
    return (rawOptionName || 'Option')
      .replace(/\s+/g, ' ')
      .trim()
      .replace(/^Select\s+a\s+/i, '')
      .replace(/^Select\s+/i, '')
      .replace(/:$/, '')
      .trim();
  }

  updateSelectionSummaryFromSelected() {
    const summary = document.getElementById('variant-selection-summary');
    if (!summary) return;

    const selectedLabels = document.querySelectorAll('.product-form__input label.selected');
    const selections = Array.from(selectedLabels).map((selectedLabel) => {
      const voiceText = selectedLabel.getAttribute('aria-label') || selectedLabel.getAttribute('data-voice-label');
      if (voiceText) return voiceText;

      const labelSet = selectedLabel.closest('.variant-set');
      const optionName = this.normalizeOptionName(labelSet?.querySelector('legend')?.textContent);
      const value = selectedLabel.getAttribute('data-value') || selectedLabel.textContent.trim();
      return optionName && value ? `${optionName}: ${value}` : value;
    }).filter(Boolean);

    summary.textContent = selections.length
      ? selections.join(', ')
      : '';
  }

  restoreFocusAfterNavigation() {
    const focusId = sessionStorage.getItem('restoreFocusId');
    const scrollY = sessionStorage.getItem('restoreScrollY');
    if (!focusId && !scrollY) return;

    sessionStorage.removeItem('restoreFocusId');
    sessionStorage.removeItem('restoreScrollY');

    requestAnimationFrame(() => {
      if (scrollY) window.scrollTo(0, Number(scrollY));
      if (focusId) {
        const container = document.getElementById(focusId) || document.querySelector('variant-radios');
        if (!container) return;
        const selectedLabel = container.querySelector('label.selected') || container.querySelector('label[tabindex="0"]');
        const target = selectedLabel || container;

        target.classList.add('restore-focus-target');
        target.setAttribute('tabindex', '-1');
        target.focus?.();
        setTimeout(() => {
          target.classList.remove('restore-focus-target');
          target.removeAttribute('tabindex');
        }, 300);
      }
    });
  }
  

  updateUIBasedOnVariant(varid, varinv, selectedLabels) {
    if (varid === '') {
      let cuteOptName = ` Size ${selectedLabels[1].getAttribute('data-value')} ${selectedLabels[2].getAttribute('data-value')}`;
      document.querySelector('.variant-doesnt-exist').innerHTML = `Sorry. We do not have this product in ${cuteOptName}`;
      this.disableAddToCart();
    } else {
      document.querySelector('.variant-doesnt-exist').innerHTML = '';
      if (varinv == 0) {
        this.disableAddToCartOutOfStock();
        const noticeOutOfStock = document.querySelector('.notice-out-of-stock');
        const inStock = document.querySelector('.in-stock');
        const noneInStock = document.querySelector('.none-in-stock');
        const klaviyoOutOfStock = document.querySelector('.outofstock');

        if (noticeOutOfStock) noticeOutOfStock.style.display = 'block';
        if (inStock) inStock.style.display = 'none';
        if (noneInStock) noneInStock.classList.add('show');
        if (klaviyoOutOfStock) klaviyoOutOfStock.classList.add('show');
      } else {
        this.enableAddToCart(varinv);
      }
    }
    const variantInventory = document.querySelector('.variant-inventory');
    if (variantInventory) variantInventory.innerHTML = varinv;
  }

  disableAddToCart() {
    const addToCartButton = document.querySelector('.btn-product-add-to-cart');
    const quantityButtons = document.querySelectorAll('.quantity__button');
    const shopifyPaymentButton = document.querySelector('.shopify-payment-button__button');

    if (addToCartButton) addToCartButton.setAttribute('disabled', 'true');
    quantityButtons.forEach(button => button.setAttribute('disabled', 'true'));
    if (shopifyPaymentButton) shopifyPaymentButton.style.display = 'none';
  }

  disableAddToCartOutOfStock() {
    this.disableAddToCart();
    const addToCartButtonText = document.querySelector('.btn-product-add-to-cart span');
    if (addToCartButtonText) addToCartButtonText.innerHTML = 'Sold Out';
  }

  enableAddToCart(varinv) {
    const addToCartButton = document.querySelector('.btn-product-add-to-cart');
    const quantityButtons = document.querySelectorAll('.quantity__button');
    const noticeOutOfStock = document.querySelector('.notice-out-of-stock');
    const inStock = document.querySelector('.in-stock');
    const noneInStock = document.querySelector('.none-in-stock');
    const klaviyoOutOfStock = document.querySelector('.outofstock');
    const shopifyPaymentButton = document.querySelector('.shopify-payment-button__button');
    const addToCartButtonText = document.querySelector('.btn-product-add-to-cart span');

    if (addToCartButton) addToCartButton.removeAttribute('disabled');
    quantityButtons.forEach(button => button.removeAttribute('disabled'));
    if (noticeOutOfStock) noticeOutOfStock.style.display = 'none';
    if (noneInStock) noneInStock.classList.remove('show');
    if (klaviyoOutOfStock) klaviyoOutOfStock.classList.remove('show');
    if (shopifyPaymentButton) shopifyPaymentButton.style.display = 'block';
    if (addToCartButtonText) addToCartButtonText.innerHTML = 'Buy Now';

    if (varinv <= 13) {
      if (inStock) {
        inStock.innerHTML = `Only <span class="num">${varinv}</span> in stock`;
        inStock.style.display = 'block';
      }
    } else {
      if (inStock) {
        inStock.innerHTML = '';
        inStock.style.display = 'none';
      }
    }

    // console.log('Inventory updated:', varinv); // Debug log
    // console.log('In-stock element:', inStock); // Debug log
  }

  updateQuantity(button) {
    let quantityInput = document.getElementById('quantity');
    let currentValue = parseInt(quantityInput.value);
    let newVal = button.classList.contains('product-minus') ? Math.max(1, currentValue - 1) : currentValue + 1;
    quantityInput.value = newVal;
  }
  autoSelectSizeFromCookie() {
    // Retrieve the size from the cookie
    let dpUserCookie = CookieManager.getCookie('dp_user');
    if (!dpUserCookie) return;
  
    let userData = JSON.parse(dpUserCookie);
    let savedSize = userData.size;
  
    if (savedSize && !isNaN(savedSize)) {
      // Find the size label that matches the savedSize
      let sizeLabel = document.querySelector(`.product-form__input.set-size label[data-value="${savedSize}"]`);
      if (sizeLabel) {
        // If the size label exists, click it to select the variant
        sizeLabel.click();
        console.log(`Auto-selected size: ${savedSize}`); // Debugging
      } else {
        console.log(`Size ${savedSize} not found in product variants`); // Debugging
      }
    }
  }
  

  async addToCart(event) {
    event.preventDefault();
    let productId = document.getElementById('id').value;
  
    // Get the gender and size from #data-identifier
    const dataIdentifier = document.getElementById('data-identifier');
    let genderAdded = 'U'; // Default to unknown
    let sizeAdded = '';    // Default to empty
  
    if (dataIdentifier) {
      genderAdded = dataIdentifier.getAttribute('data-gender') || 'U';
      sizeAdded = dataIdentifier.getAttribute('size') || ''; // Fetch the size attribute
    }
  
    // Use the global CookieManager to update user data
    CookieManager.updateUserData('dp_user', genderAdded, sizeAdded, 36500); // Update the dp_user cookie
  
    // Proceed with adding the product to the cart
    try {
  
      // Proceed with adding the product to the cart
      const itemsToAdd = [
        {
          id: productId,
          quantity: 1,
        },
      ];
  
      const cart = await fetch('/cart.js').then(response => response.json());
      const hasFreeItem = cart.items.some(item => parseFloat(item.price / 100) === 0);
      if (hasFreeItem) {
        console.log('A free item is already in the cart. No additional free item will be added.');
      } else {
        // Check if there's a free product identified in the div
        const freeProductElement = document.getElementById("freeProduct");
        const freeProductOneElement = document.getElementById("autoAddOne");
        const freeProductTwoElement = document.getElementById("autoAddTwo");
        let productHandle = null;
  
        if (freeProductElement) {
          productHandle = freeProductElement.getAttribute("data-id");
        } else if (freeProductOneElement) {
          productHandle = freeProductOneElement.getAttribute("data-prod");
        } else if (freeProductTwoElement) {
          productHandle = freeProductTwoElement.getAttribute("data-prod");
        }
  
        console.log('Product Handle: ' + productHandle);
  
        if (productHandle) {
          try {
            // Fetch product details for inventory check
            const response = await fetch(`${window.Shopify.routes.root}products/${productHandle}.js`);
            if (response.ok) {
              const product = await response.json();
  
              console.log('Product');
              console.log(product);
              if (product.variants && product.variants.length > 0) {
                const variant = product.variants[0]; // Assuming we're using the first variant
  
                console.log('Variant');
                console.log(variant);
                console.log(variant.inventory_quantity);
                if (variant.available) {
                  // Add free product to itemsToAdd list if inventory is sufficient
                  itemsToAdd.push({
                    id: variant.id,
                    quantity: 1,
                  });
                } else {
                  console.warn("Free product is not available.");
                }
              } else {
                console.warn("No variants found for the free product");
              }
            } else {
              console.warn("Failed to fetch free product information");
            }
          } catch (error) {
            console.warn(`Error fetching free product data: ${error.message}`);
          }
        }
      }
  
      // Proceed with adding the main product and any free products (if available) to the cart
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({ items: itemsToAdd }),
      });

      if (!addResponse.ok) {
        const error = await addResponse.json();
        throw new Error(error.message);
      }

      const data = await addResponse.json();
      console.log("Products added to cart:", data);

      // Update the mini cart
      this.updateMiniCart(data);
      this.toggleMiniCart(true);
      

      // Update header cart count
      const updatedCart = await fetchCartData();
      updateHeaderCartCount(updatedCart.item_count);

      
    } catch (err) {
      console.error('Error adding to cart:', err);
    }
  }
  
  
  

  updateMiniCart(cart) {
    if (typeof fetchCartData === "function") {
      fetchCartData();
    } else {
      console.error('fetchCartData function is not defined');
    }
  }

  toggleMiniCart(open) {
    const minicartSection = document.getElementById('shopify-section-ocs-minicart');
    const minicartbod = document.getElementById('ocs-minicart');
  
    if (!minicartbod) {
      console.error('Mini cart body element not found!');
      return;
    }
  
    if (open) {
      minicartSection.classList.add('open');
      document.body.classList.add('noscroll');
      minicartbod.setAttribute('aria-hidden', 'false');
  
      // Set focus on the mini cart body
      minicartbod.focus();
  
      // Ensure it has a focusable state
      minicartbod.setAttribute('tabindex', '0');
  
      // Set up focus trap
      this.setFocusTrap(minicartbod);
    } else {
      minicartSection.classList.remove('open');
      document.body.classList.remove('noscroll');
      minicartbod.setAttribute('aria-hidden', 'true');
  
      // Remove focus trap
      this.removeFocusTrap(minicartbod);
  
      minicartbod.blur();
    }
  }

  hoverZoomEnter(container) {
    // Event ready for individual container adjustments if needed.
  }

  hoverZoomLeave(container) {
    container.querySelector('img').style.transform = 'translate(0%, 0%)';
  }

  hoverZoomMove(container, event) {
    let objOffset = container.getBoundingClientRect();
    let targetWidth = container.offsetWidth;
    let targetHeight = container.offsetHeight;

    let offsetX = event.clientX - objOffset.left;
    let offsetY = event.clientY - objOffset.top;

    let mouseXPercentage = offsetX / targetWidth;
    let mouseYPercentage = offsetY / targetHeight;

    let translateX = ((mouseXPercentage - 0.5) * 2 * -40) - 20;
    let translateY = ((mouseYPercentage - 0.5) * 2 * -50) - 30;

    container.querySelector('img').style.transform = `translate(${translateX}%, ${translateY}%)`;
  }

  checkHoverZoom() {
    let check = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(navigator.userAgent || navigator.vendor || window.opera);
    let browserWidth = window.innerWidth;
    let galleryFrames = document.querySelectorAll('.gallery-viewer .frame');
    if (!check && browserWidth >= 1000) {
      galleryFrames.forEach(frame => frame.classList.add('hover-zoom'));
    } else {
      galleryFrames.forEach(frame => frame.classList.remove('hover-zoom'));
    }
  }


  trackViewedProduct() {
    // Check for scrolling more than 1000px
    window.addEventListener('scroll', () => {
      if (window.scrollY > 400) {
        this.hasScrolled = true;
        this.checkViewConditions();
      }
    });
  
    // Check if the user has been on the page for more than 10 seconds
    setTimeout(() => {
      this.timeOnPage = true;
      this.checkViewConditions();
    }, 5000);
  }
  
  checkViewConditions() {
    if (this.hasScrolled && this.timeOnPage && !this.hasRecorded) {
      // Get product details from the #data-viewed div
      const viewedElement = document.getElementById('data-viewed');
      if (!viewedElement) return;
  
      const productDetails = {
        handle: viewedElement.getAttribute('data-handle'),
        image: viewedElement.getAttribute('data-image'),
        title: viewedElement.getAttribute('data-title'),
        price: viewedElement.getAttribute('data-price')
      };
  
      // Pass the product details to updateViewedHistory
      this.updateViewedHistory(productDetails);
  
      // Mark as recorded to prevent multiple recordings
      this.hasRecorded = true;
    }
  }
  
  updateViewedHistory(productDetails) {
    let dpUserCookie = CookieManager.getCookie('dp_user');
    let cookieData = dpUserCookie ? JSON.parse(dpUserCookie) : { viewedHistory: [] };
  
    // Ensure viewedHistory is always an array
    if (!Array.isArray(cookieData['viewedHistory'])) {
      cookieData['viewedHistory'] = [];
    }
  
    // Check if the product handle already exists in the viewedHistory
    const productExists = cookieData['viewedHistory'].some(item => item.handle === productDetails.handle);
  
    // If the product already exists, do not add it again
    if (productExists) return;
  
    // Add the product details to the front of the list
    cookieData['viewedHistory'].unshift(productDetails);
  
    // Limit the history to the last 20 viewed products (optional)
    if (cookieData['viewedHistory'].length > 20) {
      cookieData['viewedHistory'].pop();
    }
  
    // Update the dp_user cookie with the new viewedHistory
    CookieManager.setCookie('dp_user', JSON.stringify(cookieData), 365);
  }

}

document.addEventListener('DOMContentLoaded', () => new ProductPage());
